import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/react';
import { StatusEnvelopeSchema } from '@agentbrush/shared';
import type { StatusResponseData } from '@agentbrush/shared';
import { useApiClient } from './use-api-client.js';

export type QuotaData = StatusResponseData;

// Story 11.1 Task 0b: namespace React Query keys by Clerk userId so a session
// switch without full page reload cannot leak cached data between users.
export const quotaQueryKey = (userId: string | null | undefined) =>
  ['quota', userId ?? 'anon'] as const;

export function useQuotaQuery({ polling = false } = {}) {
  const { fetchApi } = useApiClient();
  const { userId } = useAuth();

  return useQuery<QuotaData>({
    queryKey: quotaQueryKey(userId),
    queryFn: async () => {
      const res = await fetchApi('/v1/status');
      if (!res.ok) {
        throw new Error(`Status ${res.status}`);
      }

      const body = await res.json();
      return StatusEnvelopeSchema.parse(body).data;
    },
    enabled: Boolean(userId),
    staleTime: 15_000,
    refetchInterval: polling ? 30_000 : false,
  });
}
